import { useIntl } from 'react-intl';

import * as messages from '../messages.ts';

import { PriceAltContainer } from './price-alt-container.tsx';
import {
	ProductPriceCardProps,
	FreePriceCard,
	StandardPriceCard,
	PremiumPriceCard,
	EnterprisePriceCard,
} from './pricing-calculator-plan-card.tsx';

export const JiraProductDiscoveryFreePriceCard = (props: ProductPriceCardProps) => {
	return <FreePriceCard {...props} />;
};

export const JiraProductDiscoveryStandardPriceCard = (props: ProductPriceCardProps) => {
	const intl = useIntl();

	return (
		<StandardPriceCard
			{...props}
			tierLabelType="user"
			monthlyPerUserLabel={intl.formatMessage({
				id: 'JiraProductDiscoveryPriceCard.perCreatorPerMonth',
				defaultMessage: 'per creator / month',
			})}
			priceAltElementForAboveMaxThreshold={
				<PriceAltContainer>
					{intl.formatMessage(messages.aboveUnitMaxThreshold.creators)}
				</PriceAltContainer>
			}
		/>
	);
};

export const JiraProductDiscoveryPremiumPriceCard = (props: ProductPriceCardProps) => {
	const intl = useIntl();
	return (
		<PremiumPriceCard
			{...props}
			tierLabelType="user"
			monthlyPerUserLabel={intl.formatMessage({
				id: 'JiraProductDiscoveryPriceCard.perCreatorPerMonth',
				defaultMessage: 'per creator / month',
			})}
			priceAltElementForAboveMaxThreshold={
				<PriceAltContainer>
					{intl.formatMessage(messages.aboveUnitMaxThreshold.creators)}
				</PriceAltContainer>
			}
		/>
	);
};

export const JiraProductDiscoveryEnterprisePriceCard = (props: ProductPriceCardProps) => {
	return <EnterprisePriceCard {...props} />;
};
